import { ExportBiRun, Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveExportBiRun(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    startDate: string,
    endDate: string,
  ) =>
    httpClient.sendHttpRequest<ExportBiRun>({
      endpoint: `/admin/exports/planzones/${uuid}`,
      method: HttpMethods.POST,
      data: { startDate, endDate },
    });
}

export { saveExportBiRun };
